<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .custom-tab-header {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: utils.in_rem(2px);
  }

  .custom-tab-item {
    font-size: utils.in_rem(14px);
    font-weight: 700;
    width: 210px;
    padding: utils.in_rem(12px) 0;
    text-align: center;
    border-radius: utils.in_rem(10px) utils.in_rem(10px) 0 0;
    cursor: pointer;
  }

  .custom-tab-item.active {
    @include colors.color(primary_50);
    background-color: white;
  }

  .custom-tab-item:not(.active) {
    background: colors.get(interfaceSwGrey_10);
  }

  .custom-tab-item:not(.active):hover {
    @include colors.color(primary_50);
    background: colors.get(primary_5);
  }
</style>

<script>
  import { writable } from "svelte/store";

  export let tabItems = [];

  export let currentType = writable(tabItems[0]?.kind || "");

  // Handle tab click
  const handleTabClick = (item) => {
    currentType.set(item.kind);
  };

  // Handle keyboard events for accessibility
  const handleKeyDown = (item, event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleTabClick(item);
    }
  };
</script>

<!-- Custom tab panel implementation -->
<div class="custom-tab-panel">
  <ul class="custom-tab-header" role="tablist">
    {#each tabItems as item}
      <li
        class="custom-tab-item"
        class:active={item.kind === $currentType}
        on:click={() => handleTabClick(item)}
        on:keydown={(event) => handleKeyDown(item, event)}
        tabindex="0"
        role="tab"
      >
        {item.label}
      </li>
    {/each}
  </ul>
</div>
